import React from 'react';
import { AdminLayout } from '../../../design-system/components/layouts';
import {
  PageHeader,
  Input,
  Select,
  Checkbox,
  FormSection,
  FormActions,
  Card,
  CardBody,
} from '../../../design-system/components';
import { useInertiaForm } from '../../../hooks';
import {
  admin_fraud_rules_path,
  admin_fraud_custom_rules_path,
  admin_fraud_custom_rule_path,
} from '../../../lib/routes';
const CUSTOM_FIELDS = [
  {
    value: 'utm_source',
    label: 'UTM Source',
  },
  {
    value: 'referer',
    label: 'Referer',
  },
  {
    value: 'user_agent',
    label: 'User Agent',
  },
  {
    value: 'ip_address',
    label: 'IP Address',
  },
  {
    value: 'email_domain',
    label: 'Email Domain',
  },
];
const CUSTOM_OPERATORS = [
  {
    value: 'equals',
    label: 'Equals',
  },
  {
    value: 'contains',
    label: 'Contains',
  },
  {
    value: 'matches_regex',
    label: 'Matches Regex',
  },
  {
    value: 'in_list',
    label: 'In List',
  },
];
const ACTIONS = [
  {
    value: 'flag',
    label: 'Flag for Review',
  },
  {
    value: 'auto_reject',
    label: 'Auto Reject',
  },
  {
    value: 'auto_deactivate',
    label: 'Auto Deactivate',
  },
];
export default function CustomRuleForm({ rule, is_new }) {
  const config = rule.config || {};
  const form = useInertiaForm({
    'fraud_rule[name]': rule.name || '',
    'fraud_rule[action]': rule.action || 'flag',
    'fraud_rule[enabled]': rule.enabled ? '1' : '0',
    'fraud_rule[field]': config.field || 'utm_source',
    'fraud_rule[operator]': config.operator || 'equals',
    'fraud_rule[value]': config.value || '',
  });
  function handleSubmit(e) {
    e.preventDefault();
    if (is_new) {
      form.post(admin_fraud_custom_rules_path());
    } else {
      form.patch(admin_fraud_custom_rule_path(rule.id));
    }
  }
  return (
    <AdminLayout>
      <PageHeader
        title={is_new ? 'New Custom Rule' : `Edit: ${rule.name}`}
        description={
          is_new ? 'Create a custom fraud detection rule' : 'Update custom rule configuration'
        }
      />

      <div className="mt-6 max-w-2xl">
        <Card>
          <CardBody>
            <form onSubmit={handleSubmit} className="space-y-6">
              <FormSection heading="Rule Details">
                <Input
                  label="Rule Name"
                  name="fraud_rule[name]"
                  value={form.data['fraud_rule[name]']}
                  onChange={(e) => form.setData('fraud_rule[name]', e.target.value)}
                  error={form.errors['fraud_rule[name]']}
                  required
                />
                <Select
                  label="Action"
                  name="fraud_rule[action]"
                  value={form.data['fraud_rule[action]']}
                  onChange={(e) => form.setData('fraud_rule[action]', e.target.value)}
                >
                  {ACTIONS.map((a) => (
                    <option key={a.value} value={a.value}>
                      {a.label}
                    </option>
                  ))}
                </Select>
                <Checkbox
                  label="Enable this rule"
                  description="When enabled, this rule will actively check new referrals"
                  checked={form.data['fraud_rule[enabled]'] === '1'}
                  onChange={(e) =>
                    form.setData('fraud_rule[enabled]', e.target.checked ? '1' : '0')
                  }
                />
              </FormSection>

              <FormSection heading="Matching Criteria">
                <Select
                  label="Field"
                  name="fraud_rule[field]"
                  value={form.data['fraud_rule[field]']}
                  onChange={(e) => form.setData('fraud_rule[field]', e.target.value)}
                >
                  {CUSTOM_FIELDS.map((f) => (
                    <option key={f.value} value={f.value}>
                      {f.label}
                    </option>
                  ))}
                </Select>
                <Select
                  label="Operator"
                  name="fraud_rule[operator]"
                  value={form.data['fraud_rule[operator]']}
                  onChange={(e) => form.setData('fraud_rule[operator]', e.target.value)}
                >
                  {CUSTOM_OPERATORS.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </Select>
                <Input
                  label="Value"
                  name="fraud_rule[value]"
                  value={form.data['fraud_rule[value]']}
                  onChange={(e) => form.setData('fraud_rule[value]', e.target.value)}
                  helperText={
                    form.data['fraud_rule[operator]'] === 'in_list'
                      ? 'Comma-separated list of values'
                      : form.data['fraud_rule[operator]'] === 'matches_regex'
                        ? 'Regular expression pattern'
                        : 'The value to match against'
                  }
                />
              </FormSection>

              <FormActions
                submitLabel={is_new ? 'Create Rule' : 'Update Rule'}
                cancelHref={admin_fraud_rules_path()}
                processing={form.processing}
              />
            </form>
          </CardBody>
        </Card>
      </div>
    </AdminLayout>
  );
}
